import React from 'react'
import {ListGuesser} from '@api-platform/admin'
import {Filter, TextInput, TextField, BooleanField} from 'react-admin'
import ListPagination from "../../../components/admin/ListPagination"

import PostBulkActionButtons from "../../../components/admin/PostBulkActionButtons";
import ListActions from "../../../components/admin/Actions";
import {useTranslation} from "react-i18next";

function List(props) {
    const {t} = useTranslation()
    return (
        <ListGuesser
            perPage={30}
            title={t('menu.companies')}
            pagination={<ListPagination/>}
            {...props}
            filters={<Filter>
                <TextInput label={t('common.name')} source="name"/>
                <TextInput label={t('brief.company')} source="company.name"/>
            </Filter>}
            bulkActionButtons={<PostBulkActionButtons
                //showExportButton={true}
                showDeleteButton={true/*Roles.hasAccess('ClientsEdit')*/}
            />}
            actions={<ListActions
                showNewButton={false/*Roles.hasAccess('ClientsEdit')*/}
                //showExportButton={true}
            />}
            sort={{ field: 'order', order: 'ASC' }}
        >
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <TextField source="description" label={t('admin.description')}/>
            <BooleanField source="isDefault" label={t('admin.isDefault')}/>
            <TextField source="order" label={t('admin.order')}/>
            <TextField source="code" label={t('admin.code')}/>
            <TextField source="duration" label={t('admin.duration')}/>
        </ListGuesser>
    )
}

export default List
